<template>
  <w-button

    :class="btn.class"
    :bg-color="btn.bg"
    :icon="nolabel ? btn.icon : ''"
    
  >
  <w-icon
    v-if="icon"
    class="mr1"
  >
  {{ icon }}
  </w-icon>
  <w-icon
    v-else
    class="mr1"
  >
  {{ btn.icon }}
  </w-icon>

  <slot>
    {{ label }}
  </slot>

  <template #loading>
    <w-icon
      class="mr1"
    >
    fal fa-spinner fa-spin
    </w-icon>
    Proses...
  </template>
  </w-button>
</template>


<script>

export default {
  name: 'z-button',
  props: {
    save: Boolean,
    submit: Boolean,
    reset: Boolean,
    cancel: Boolean,
    search: Boolean,
    filter: Boolean,
    nolabel: Boolean,
    icon: String,
  },
  data() {
    return {
      btn: {
        icon: '',
        class: ''
      }
    }
  },
  computed: {
    label() {
      let label = ''

      if(this.save) {
        label = 'Simpan'
        this.btn.bg = 'success'
        this.btn.class = 'white'
        this.btn.icon = 'fal fa-save'
      } else if(this.submit) {
        label = 'Hantar'
        this.btn.bg = 'success'
        this.btn.class = 'white'
        this.btn.icon = 'fal fa-paper-plane'
      } else if(this.reset) {
        label = 'Reset'
        this.btn.bg = 'warning'
        this.btn.class = 'white'
        this.btn.icon = 'fal fa-sync'
      } else if(this.cancel) {
        label = 'Batal'
        this.btn.bg = 'error-dark2'
        this.btn.class = 'white'
        this.btn.icon = 'fal fa-times'
      } else if(this.search) {
        label = 'Cari'
        this.btn.bg = 'blue-grey'
        this.btn.class = 'white'
        this.btn.icon = 'fal fa-search'
      } else if(this.filter) {
        label = 'Tapis'
        this.btn.bg = 'blue-grey'
        this.btn.class = 'white'
        this.btn.icon = 'fal fa-filter'
      }
      this.btn.icon = this.icon ?? this.btn.icon
      if(!this.nolabel) {
        return label
      }

    }
  }
}

</script>